export const documentFields = {
  // AIRA Document FIelds
  OfferNumber: `Offer Number`,
  DeliveryTerms: `Delivery Terms`,
  OrderDate: `Order Date`,
  OrderNumber: `Order Number`,
};
